module.exports = __webpack_public_path__ + "img/DisabledFeedbackPoor.ac539ca1.png";